// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"mainStyle_custom-scrollbar__fl5Do","custom-scrollbar-menu":"mainStyle_custom-scrollbar-menu__nxAVD"};